import React from 'react'

import { GradientBackgroundScreen } from '@newComponents/Screen'
import { Card } from '@newComponents/Card'

import { PresentationScreenContentWrapper } from './PresentationScreenContentWrapper'

export const PresentationScreen = () => {
  return (
    <GradientBackgroundScreen alignItems='center'>
      <Card
        maxWidth='100%'
        $gtSm={{
          maxWidth: 600,
        }}
      >
        <PresentationScreenContentWrapper />
      </Card>
    </GradientBackgroundScreen>
  )
}

export default PresentationScreen
